import { computed, type Ref } from "vue";

export default function useHiddenWalletAddress(addressRef: Ref<string> | string) {
    return computed(() => {
        const address = typeof addressRef === 'string' ? addressRef : addressRef.value;
        return address.slice(0, 6) + '...' + address.slice(-4);
    });
}